import store from '@/store'

export default {
  install: (Vue, options) => {
    Vue.prototype.$theme = {
      set: async (document) => {
        Vue.prototype.$http.get('/api/auth/getuser')
          .then(({ data }) => {
            localStorage.setItem('user', JSON.stringify(data.data))
            store.commit('UPDATE_USER', { user: data.data })

            document.documentElement.style.setProperty('--theme-primary-color', data.data.school.color)
            document.documentElement.style.setProperty('--theme-primary-font', data.data.school.font)
          }).catch((error) => {
            console.log(error)
          })
      },
    }
  },
}
